
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  FilteredUserPayload,
  FilteredUserQueryParam
} from '@/store/modules/users/types/users.types';
import dayjs from 'dayjs';
import { initialState } from './filter-state.util';

@Component({
  components: {}
})
export default class SearchBox extends Vue {
  @Prop(Object) public filterParams!: FilteredUserPayload;

  public dateToDisplayedDate(dates: string[]) {
    if (Array.isArray(dates) && dates.length > 1) {
      if (dates.some((d) => !d)) {
        alert(`Invalid Date Range ${JSON.stringify(dates)}`);
        return;
      }

      const startDate = dates?.[0]
        ? dayjs(dates?.[0]).format('DD MMM YYYY')
        : undefined;
      const endDate = dates?.[1]
        ? dayjs(dates?.[1]).format('DD MMM YYYY')
        : undefined;

      return `${startDate} - ${endDate}`;
    }
  }

  public handleReset() {
    this.$emit('input', initialState);
  }
}
